

angular.module('admin')
.filter('shorttime', function () {
    return function(text) {
    	if (typeof text != 'string') return text;
        return text.replace(/(\d\d:\d\d):\d\d(?:\.\d*)/g, '$1');
    }
})